import { render, staticRenderFns } from "./ArchiveProposals.vue?vue&type=template&id=45a76f6b&scoped=true&"
import script from "./ArchiveProposals.vue?vue&type=script&lang=js&"
export * from "./ArchiveProposals.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveProposals.vue?vue&type=style&index=0&id=45a76f6b&prod&lang=css&"
import style1 from "./ArchiveProposals.vue?vue&type=style&index=1&id=45a76f6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a76f6b",
  null
  
)

export default component.exports